import ExternalTrackMap3DHandler from "../utils/ExternalTrackMap3DHandler.js";
import LiveChatWidget from "../utils/LiveChatWidget";

export default class ExternalTrackLive {
    constructor() {
        this.mode = null;
        this.tracks = [];
        this.handler = null;
        this.external_track_ids = [];
        this.socket_initialized = false;
        this.subscribed_track_ids = new Set();
        this.loading_users = new Set(); 
        this.subscribed_group_ids = new Set();

        this.bindEvents();
        this.liveChat = new LiveChatWidget();
    }

    bindEvents() {
        window.application.setOnDataChangeListener(this);
    }

    bindSocket() {
        var self = this;
        $(document).off('socket-LiveChannel').on('socket-LiveChannel', function (e, data) {
            self.onSocketMessageReceived(data);
        });

        if (this.external_group_ids && this.external_group_ids.length > 0) {            
            this.external_group_ids.forEach(group_id => {
                if (!group_id) return; 
                const channelId = `external_group_${group_id}`;
                if (!this.subscribed_group_ids.has(channelId)) {
                    console.log(`ExternalTrackLive: Subscribing to channelId=${channelId}`);
                    window.application.socket_handler.subscribe({
                        channel: "LiveChannel",
                        id: channelId
                    });
                    this.subscribed_group_ids.add(channelId);
                } 
            });
        } 

        // Subscribe to external track channels
        this.external_track_ids.forEach(track_id => {
            const channelId = `external_track_${track_id}`;
            if (!this.subscribed_track_ids.has(channelId)) {
                console.log(`ExternalTrackLive: Subscribing to channelId=<${channelId}`);
                window.application.socket_handler.subscribe({ 
                    channel: "LiveChannel", 
                    id: channelId 
                });
                this.subscribed_track_ids.add(channelId);
            }
        });
    }

    async onDataChanged(data) {
        this.mode = data.mode;
        this.session = data.session;
        this.tracks = data.session.tracks;
        
        this.external_track_ids = this.tracks.map(track => track.id);

        const trackGroupIds = this.tracks
            .flatMap(track => track.group_ids || [track.group_id])
            .filter(id => id !== null && id !== undefined && id !== "");
            
        const globalGroupIds = data.group_ids || [];
        const singleGroupId = data.group_id ? [data.group_id] : [];
        
        this.external_group_ids = [...new Set([...trackGroupIds, ...globalGroupIds, ...singleGroupId])]
            .filter(id => id !== null && id !== undefined && id !== "");

        if (this.mode == "3D") {
            this.handler = new ExternalTrackMap3DHandler(data.first_appear_ad, data.frequency_ad);
            await this.handler.init(data);
            await this.liveChat.initTimelineComments();

            this.handler.onTickChanges((currentTime) => {
                this.currentTime = currentTime;
                this.liveChat.setCurrentTick(currentTime);
            });
            this.liveChat.subscribeToPlayerData();
        }

        if (this.socket_initialized == false) {
            this.bindSocket();
            this.socket_initialized = true;
        }
    }

    getBackTrack(trackId, userId, userName) {
        const self = this;
        const userKey = `${userName}_${trackId}`;
        
        // Check if already loading this user to prevent duplicates
        if (this.loading_users.has(userKey)) {
            return Promise.resolve();
        }
        
        this.loading_users.add(userKey);
        
        return new Promise((resolve, reject) => {
            const ajaxData = {
                url: window.application.getAPIUrl() + "/v1/external_track/" + trackId,
                method: "GET",
                beforeSend: this.handler ? this.handler.beforeSendHandler : null,
            };
            
            $.ajax(ajaxData).done((responseData) => {               
                if (self.handler && responseData.points && responseData.points.length > 0) {
                    // Convert raw points to expected format and add to handler
                    self.handler.addTrackToScene(trackId, userId, userName, responseData);
                }
                self.loading_users.delete(userKey);
                resolve(responseData);
            }).fail((err) => {
                console.error("ExternalTrackLive: Failed to load back track for user", userName, trackId, err);
                self.loading_users.delete(userKey);
                reject(err);
            });
        });
    }

    onSocketMessageReceived(data) {
        this.liveChat.timelineManager && this.liveChat.timelineManager.recalculatePositions();
        if (data.e == "point-add" && data.external) {
            this.handler.onPointReceived(data);
        } else if (data.e == "track_end" && data.external) {
            this.handler.onPointReceived(data);
        } else if(data.e=="user-around") {            
            const channelId = `external_track_${data.tid}`;
            if (!this.subscribed_track_ids.has(channelId)) {
                console.log(`ExternalTrackLive: Subscribing to new channelId=${channelId}`);
                window.application.socket_handler.subscribe({ channel: "LiveChannel", id: channelId });
                this.subscribed_track_ids.add(channelId);
            }
            
            this.getBackTrack(data.tid, data.uid, data.uname);
		}
    }
}